import React, { Component } from 'react'
import { connect } from 'react-redux'
import { histSearchPage } from '../redux/actions'
import SearchBar from '../components/searchBar'
import autobind from 'autobind-decorator'
import { clearAppCache } from '../redux/stateUtils'

@autobind
class SearchScreen extends Component {
  componentWillMount() {
    clearAppCache()
    localStorage.removeItem('searchDetails')
  }

  componentWillUnmount() {
    let { dispatch } = this.props
    dispatch(histSearchPage())
  }

  render() {
    return <SearchBar showDetailsText={true} />
  }
}

export default connect()(SearchScreen)



// WEBPACK FOOTER //
// ./src/containers/searchScreen.js